import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { GroupsService } from "../services/groups.service";
import { eventScanModel } from "./eventScanModel";
import { ViewDetailsComponent } from "./view-details/view-details.component";
import * as moment from "moment";

@Component({
	selector: "app-events-event-scanning-results",
	templateUrl: "./events-event-scanning-results.component.html",
	styleUrls: ["./events-event-scanning-results.component.css", "../groups.css"],
})
export class EventsEventScanningResultsComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private groupService: GroupsService,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////
	// Data
	////////////////////////////////////

	subscription: any;

	SchoolLoading: any = true;
	EventLoading: any = true;
	ScanLoading: any = true;

	//Data for filtering and selecting results
	scanData = {
		SchoolID: 0,
		EventID: 0,
		startDate: new Date(),
		endDate: new Date(),
		SelectedEventScanID: -1,
	};

	cols = [
		{ field: "StudentID", header: "Student ID" },
		{ field: "PersonName", header: "Student Name" },
		{ field: "EventScanTypeDesc", header: "Scan Result" },
		{ field: "EventScanDTDesc", header: "Event Scan Date/Time" },
		{ field: "ScanStation", header: "Scan Station" },
	];

	lstSchool: any = [];
	lstEvent: any = [];

	//Formatted data for table
	lstEventScans: any = [];

	//List for raw data
	scanList: any = [];

	pagefirst: Number = 0;
	pagerows: Number = 10;
	SelectedEventScan: any;
	errorMessage: any = "";

	//Filtering Data
	lstScanResult: any = [];
	lstScanStation: any = [];
	lstStudentID: any = [];
	////////////////////////////////////

	///////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////

	private loadSchoolist() {
		this.SchoolLoading = true;

		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.scanData.SchoolID = this.lstSchool[0].SchoolID;

				this.SchoolLoading = false;

				//Load events
				this.loadEventList();
			},
			(error) => {
				this.SchoolLoading = false;
			}
		);
	}

	private loadEventList() {
		this.EventLoading = true;

		//Check if the dates are valid (typing in values would send a request with a year like 200 or 20)
		//var startYear = this.scanData.startDate.getFullYear();
		//var endYear = this.scanData.endDate.getFullYear();
		//if(startYear < 1900){
		//  this.EventLoading = false;
		//  return;
		//}
		//if(endYear < 1900){
		//  this.EventLoading = false;
		//  return;
		//}

		var fsDate = moment(this.scanData.startDate).format("MM/DD/YYYY");
		var feDate = moment(this.scanData.endDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.SchoolLoading = false;
			this.EventLoading = false;
			this.ScanLoading = false;

			return;
		}

		// var result = this.groupService.loadEventList("", this.scanData.SchoolID, moment(this.scanData.startDate).format("MM/DD/YYYY"), moment(this.scanData.endDate).format("MM/DD/YYYY"), 'All');
		var result = this.groupService.C9EventsGetList(
			this.scanData.SchoolID,
			moment(this.scanData.startDate).format("MM/DD/YYYY"),
			moment(this.scanData.endDate).format("MM/DD/YYYY"),
			2
		);
		result.subscribe(
			(response) => {
				this.lstEvent = response;

				if (this.lstEvent.length > 0) {
					this.scanData.EventID = this.lstEvent[0].EventID;

					for (var z = 0; z < this.lstEvent.length; z++) {
						var next = this.lstEvent[z];

						next.EventDescLong = next.EventDescription.EventDescLong;
						next.EventDescShort = next.EventDescription.EventDescShort;
						next.EventDescriptionID = next.EventDescription.EventDescriptionID;
					}
				} else {
					this.scanData.EventID = -1;
				}

				this.EventLoading = false;

				this.loadScanList();
			},
			(error) => {}
		);
	}

	//Load Scan List
	private loadScanList() {
		if (this.scanData.EventID == -1) {
			this.scanList = [];

			this.lstEventScans = [];
			this.lstScanResult = [];
			this.lstScanStation = [];
			this.lstStudentID = [];

			this.ScanLoading = false;

			return;
		}

		this.ScanLoading = true;

		//Check if the dates are valid (typing in values would send a request with a year like 200 or 20)
		//var startYear = this.scanData.startDate.getFullYear();
		//var endYear = this.scanData.endDate.getFullYear();
		//if(startYear < 1900){
		//  this.ScanLoading = false;
		//  return;
		//}
		//if(endYear < 1900){
		//  this.ScanLoading = false;
		//  return;
		//}

		var fsDate = moment(this.scanData.startDate).format("MM/DD/YYYY");
		var feDate = moment(this.scanData.endDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.SchoolLoading = false;
			this.EventLoading = false;
			this.ScanLoading = false;

			return;
		}

		// var result = this.groupService.loadScanList("", this.scanData.EventID, ScanOpt,  moment(this.scanData.startDate).format("MM/DD/YYYY"), moment(this.scanData.endDate).format("MM/DD/YYYY"));
		var result = this.groupService.loadScanList(
			"",
			this.scanData.EventID,
			1,
			moment(this.scanData.startDate).format("MM/DD/YYYY"),
			moment(this.scanData.endDate).format("MM/DD/YYYY")
		);
		result.subscribe(
			(response) => {
				this.scanList = response;
				this.scanData.SelectedEventScanID = -1;

				//Update Table data
				this.UpdateData();
			},
			(error) => {
				this.ScanLoading = false;
			}
		);
	}

	UpdateData() {
		this.lstEventScans = [];

		this.lstScanResult = [];
		this.lstScanStation = [];
		this.lstStudentID = [];

		for (var i = 0; i < this.scanList.length; i++) {
			var next = this.scanList[i];

			next.EventScanDTDesc = moment(new Date(next.EventScanDT)).format("MM/DD/YYYY h:mm a");

			// let val1: eventScanModel = {
			//   EventScanID: next.EventScanID,
			//   StudentID: next.StudentID,
			//   StudentName: next.PersonName,
			//   ScanResult: next.EventScanTypeDesc,
			//   EventScanDT: next.EventScanDT,
			//   ScanStation: next.ScanStation
			// }

			// this.lstEventScans = [...this.lstEventScans, val1];

			//Updating Dropdowns:
			// Array.from(new Set(this.lstScanResult.map((item: any) => item.EventScanTypeDesc)));

			// var scanResultFound = false;
			// for(var j = 0; j < this.lstScanResult.length; j++){
			//   if(this.lstScanResult[j] == next.EventScanTypeDesc){
			//     scanResultFound = true;
			//   }
			// }

			// if(!scanResultFound){
			//   this.lstScanResult = [...this.lstScanResult, next.EventScanTypeDesc];
			// }

			// var scanStationFound = false;
			// for(var j = 0; j < this.lstScanStation.length; j++){
			//   if(this.lstScanStation[j] == next.ScanStation){
			//     scanStationFound = true;
			//   }
			// }

			// if(!scanStationFound){
			//   this.lstScanStation = [...this.lstScanStation, next.ScanStation];
			// }

			// var studentIDFound = false;
			// for(var j = 0; j < this.lstStudentID.length; j++){
			//   if(this.lstStudentID[j] == next.StudentID){
			//     studentIDFound = true;
			//   }
			// }

			// if(!studentIDFound){
			//   this.lstStudentID = [...this.lstStudentID, next.StudentID];
			// }
		}

		this.lstEventScans = this.scanList;
		this.lstScanResult = Array.from(new Set(this.scanList.map((item: any) => item.EventScanTypeDesc))).sort();
		this.lstScanStation = Array.from(new Set(this.scanList.map((item: any) => item.ScanStation))).sort();
		this.lstStudentID = Array.from(new Set(this.scanList.map((item: any) => item.StudentID))).sort();

		this.ScanLoading = false;
	}

	///////////////////////////////////////////

	////////////////////////////////////
	// Buttons
	////////////////////////////////////
	onRefresh() {
		this.loadScanList();
	}

	onRowDblClick(val) {
		this.SelectedEventScan = val;
		this.onViewDetails();
	}

	onViewDetails() {
		//Error Handling
		if (this.SelectedEventScan == null) {
			this.errorMessage = "Select an Event Scan";
			return;
		}

		//Create Popup
		var ref = this.dialogService.open(ViewDetailsComponent, {
			header: "View Details",
			width: "fit-content",
			data: {
				SelectedEventScanID: this.SelectedEventScan.EventScanID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
			}
		});
	}

	////////////////////////////////////

	////////////////////////////////////
	// Events
	////////////////////////////////////
	onSchoolChange(value) {
		if (value != 0) {
			this.errorMessage = "";
		}

		this.scanData.SchoolID = value;
		//Update Events
		this.loadEventList();
	}

	onHandleFilter(value) {}

	onHandleSort(value) {}

	onRowSelect(value) {
		//Reset Error Message
		this.errorMessage = "";

		//Set selected Event Scan
		this.SelectedEventScan = value.data;
	}

	onRowUnselect(value) {
		//Set selected Event Scan
		this.SelectedEventScan = null;
	}

	onEventChange(val) {
		this.scanData.EventID = val;

		//Update table
		this.loadScanList();
	}

	onStartDateChange(val) {
		this.scanData.startDate = val;

		this.loadEventList();
	}

	onEndDateChange(val) {
		this.scanData.endDate = val;

		this.loadEventList();
	}

	////////////////////////////////////

	////////////////////////////////////
	// Helpers
	////////////////////////////////////

	FormatDate(DT) {
		return moment(new Date(DT)).format("MM/DD/YYYY");
	}

	////////////////////////////////////
}
